module.exports = "input.form-check-input,\nlabel.form-check-label {\n    cursor: pointer;\n}\n"